import { useMemo } from 'react';
import { useSuspenseQuery } from '@tanstack/react-query';
import { API } from 'api';
import { apiName, apiBasePath } from 'assets/constants';

import { SECTIONS, DOMAINS, IMPORTANCE } from '@repo/monitoring';
import type { GutXAxisOrganConditionRow } from '@repo/types';
import { buildGutXAxisOrgans } from '@repo/utils';

const getOrganConditions = async (kitId: string) => {
  const response = await API.get(
    apiName,
    `${apiBasePath}/organs/${kitId}`,
    {},
    true,
    undefined,
    {
      tags: {
        section: SECTIONS.RESULTS,
        domain: DOMAINS.CONDITIONS,
        importance: IMPORTANCE.CRITICAL,
      },
      context: {
        kitId,
      },
    },
  );
  return response.result as GutXAxisOrganConditionRow[];
};

export const getOrganConditionsQuery = (kitId?: string) => ({
  queryKey: [apiName, 'getOrganConditions', kitId],
  queryFn: () => (kitId ? getOrganConditions(kitId) : []),
});

export const useOrgans = (kitId?: string) => {
  const organsQuery = useSuspenseQuery(getOrganConditionsQuery(kitId));

  // Grouping is memoised because it allocates: a fresh array every render would
  // defeat memoisation in the body component below it.
  const organs = useMemo(
    () => buildGutXAxisOrgans(organsQuery.data),
    [organsQuery.data],
  );

  return {
    ...organsQuery,
    organs,
  };
};

export default useOrgans;
